/**
 * Convex Client Configuration with Clerk Authentication
 */

import { ConvexReactClient } from "convex/react";

// Get Convex URL from environment variables
const convexUrl = process.env.REACT_APP_CONVEX_URL;

if (!convexUrl) {
  console.warn("⚠️ REACT_APP_CONVEX_URL not set - Convex features disabled");
}

// Create Convex client
export const convex = new ConvexReactClient(convexUrl || "");

// Export for use in providers
export default convex;